/* eslint-disable no-console */
import UsersDB from '@/firebase/users-db';
import UsersProductDB from '@/firebase/user-products-db';

// create custom unique uuid
export const uuidv44 = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^
            (crypto.getRandomValues(new Uint8Array(1))[0] &
                (15 >> (c / 4)))).toString(16)
    );
};
const uuidv4 = uuidv44();

/**
 * Create new user from firebase auth user infos
 */

export const createNewUserFromFirebaseAuthUser = async firebaseAuthUser => {
    const userDb = new UsersDB();
    const user = {
        last_position: Number(0),
        general: {
            name: firebaseAuthUser.displayName,
            image: firebaseAuthUser.photoURL,
            userId: firebaseAuthUser.uid,
            email: firebaseAuthUser.email,
        },
        state: true
    };
    await userDb.create(user, firebaseAuthUser.uid);

    const userPostDb = new UsersProductDB(firebaseAuthUser.uid);
    const post = {
        name: 'Task 1',
        desc: 'Edit your task description',
        website: '',
        active: false,
        view: true,
        priority: '',
        uuid: uuidv4,
        position: Number(0),
    };
    await userPostDb.create(post, uuidv4);
};

export const createNewPost = async postData => {
    var newNumber;
    if (postData.last_position === 0) {
        newNumber = Number(postData.last_position);
    } else {
        newNumber = Number(postData.last_position) + Number(1);
    }
    const userPostDb = new UsersProductDB(postData.userId);
    const post = {
        name: postData.name,
        desc: postData.desc,
        website: postData.website,
        active: false,
        view: true,
        priority: '',
        uuid: postData.uuid,
        position: newNumber
    };
    return await userPostDb.create(post, postData.uuid);
};